export const validatorUsername = value => {
  const regExp = new RegExp(/^[A-Za-z0-9]+$/g)
  return regExp.test(value)
}

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  // const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/ //! With character
  const regExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/ //* Without character
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validarFechaFin = (value, params) => {
  const inicio = params?.[0]

  if (value === null || value === undefined) return true
  if (inicio === null || inicio === undefined) return true

  return Number(value) >= Number(inicio)
}

export const validarFechaInicio = (value, params) => {
  const fin = params?.[0]

  if (value === null || value === undefined) return true
  if (fin === null || fin === undefined) return true

  return Number(value) <= Number(fin)
}
